import { render, staticRenderFns } from "./JSONResult.vue?vue&type=template&id=4973bcf2&scoped=true"
import script from "./JSONResult.vue?vue&type=script&lang=js"
export * from "./JSONResult.vue?vue&type=script&lang=js"
import style0 from "./JSONResult.vue?vue&type=style&index=0&id=4973bcf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4973bcf2",
  null
  
)

export default component.exports